import { useMutation } from '@tanstack/react-query';
import { mediaKitsApi } from '~/api/mediaKits';

import { MediaKitListResp } from './list';

export const useFetchDefaultMediaKit = () => {
  return useMutation({
    mutationFn: ({
      creatorId,
      token,
    }: {
      creatorId?: string;
      token?: string;
    }) =>
      mediaKitsApi
        .get<MediaKitListResp>(
          `/custom-shareable?search[]={"name":"isPublic", "comparator":"eq","value":true}${
            creatorId
              ? `&search[]={"name": "creatorId", "comparator": "in", "value": "${creatorId}"}`
              : ''
          }`,
          {
            headers: {
              'X-AUTH-TOKEN': token,
            },
          },
        )
        .then((r) => {
          const mediaKit = r.data.results.at(0);
          if (!mediaKit) {
            throw new Error('No default media kit found');
          }
          return mediaKit;
        }),
  });
};
